import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, Tooltip } from 'antd';
import { SeoTestDetails } from '../types';


type Props = {
    seoTestDetails: SeoTestDetails;
};


export default function FailedCheckTitle({ seoTestDetails }: Props) {
    const navigate = useNavigate();

    return (
        <div className="failed-check-title">
            <Icon
                className="back-icon"
                onClick={() => navigate(-1)}
                type="arrow-left"

            />
            <strong>{seoTestDetails.title}</strong>

            <Tooltip
                placement="right"
                title={
                    <span dangerouslySetInnerHTML={{ __html: seoTestDetails.description }} />
                }
            >
                <Icon
                    type="info-circle"
                    theme="filled"
                    className="info-icon"
                />
            </Tooltip>
        </div>
    );
}
